import axiosInstance from '../api';
import {
  FetchChildCommentsRequest,
  FetchChildCommentsResponse,
  CreateChildCommentRequest,
  CreateChildCommentResponse,
  UpdateChildCommentRequest,
  UpdateChildCommentResponse,
  DeleteChildCommentResponse
} from './childCommentApi.types';

/**
 * 子コメント一覧取得（親コメントID、ページネーション対応）
 * @param comment_id - 親コメントID
 * @param page - ページ番号（デフォルト: 1）
 * @param limit - 1ページあたりの件数（デフォルト: 20）
 * @returns 子コメント一覧
 */
export const fetchChildComments = async (
  comment_id: number | string,
  page: number = 1,
  limit: number = 20
): Promise<FetchChildCommentsResponse> => {
  const response = await axiosInstance.get<FetchChildCommentsResponse>('/child-comments', {
    params: { comment_id, page, limit }
  });
  return response.data;
};

/**
 * 子コメント投稿
 * @param data - 子コメント作成リクエスト
 * @returns 作成された子コメント情報
 */
export const createChildComment = async (
  data: CreateChildCommentRequest
): Promise<CreateChildCommentResponse> => {
  const response = await axiosInstance.post<CreateChildCommentResponse>('/child-comments', data, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
};

/**
 * 子コメント更新
 * @param id - 子コメントID
 * @param data - 更新内容
 * @returns 更新された子コメント情報
 */
export const updateChildComment = async (
  id: number | string,
  data: UpdateChildCommentRequest
): Promise<UpdateChildCommentResponse> => {
  const response = await axiosInstance.put<UpdateChildCommentResponse>(`/child-comments/${id}`, data, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
};

/**
 * 子コメント削除 (論理削除)
 * 子コメントをデータベースから物理的に削除せず、deleted_atフィールドを設定して
 * 削除済みとマークします。削除された子コメントは「削除されたコメント」として表示されます。
 * 
 * @param id - 子コメントID
 * @returns 削除結果
 */
export const deleteChildComment = async (
  id: number | string
): Promise<DeleteChildCommentResponse> => {
  const response = await axiosInstance.delete<DeleteChildCommentResponse>(`/child-comments/${id}`);
  return response.data;
}; 